// noinspection JSUnusedLocalSymbols
/**
 * Scripts for including the map functionality on the Map page at a tradeshow booth.
 */
(
  function (window, document, $, _, undefined) {
    /**
     * Animate values
     *
     * @param timingFn  One of elastic, back, bounce, elasticOut, backOut, bounceOut
     * @param drawFn    A function that will affect the element to be animated
     * @param duration  The duration of the animation
     * @param callback  A function to call when the animation is over
     * @param x         An additional parameter for the timing function
     */
    function animate (timingFn, drawFn, duration, callback, x) {
      const performance = _.get(window, 'performance'),
        requestAnimationFrame = _.get(window, 'requestAnimationFrame'),
        start = performance.now();

      function animateCallback (time) {
        let timeFraction = (time - start) / duration;

        if (timeFraction > 1) {
          timeFraction = 1;
        }

        const progress = timingFn(timeFraction, x);

        drawFn(progress);

        if (timeFraction < 1) {
          requestAnimationFrame(animateCallback);
        } else {
          if (_.isFunction(callback)) {
            callback();
          }
        }
      }

      requestAnimationFrame(animateCallback);
    }

    /**
     * Timing functions
     */

    function elastic (timeFraction, x) {
      return Math.pow(2, 10 * (timeFraction - 1)) * Math.cos(20 * Math.PI * x / 3 * timeFraction)
    }

    function back (timeFraction, x) {
      return Math.pow(timeFraction, 2) * ((x + 1) * timeFraction - x)
    }

    function bounce (timeFraction) {
      for (let a = 0, b = 1; 1; a += b, b /= 2) {
        if (timeFraction >= (7 - 4 * a) / 11) {
          return -Math.pow((11 - 6 * a - 11 * timeFraction) / 4, 2) + Math.pow(b, 2)
        }
      }
    }

    function makeEaseOut (timing) {
      return function (timeFraction, x) {
        return 1 - timing(1 - timeFraction, x);
      }
    }

    const elasticOut = makeEaseOut(elastic),
      backOut = makeEaseOut(back),
      bounceOut = makeEaseOut(bounce);

    /**
     * Things to do when the document has loaded
     */
    $(document).ready(
      function () {
        const mapboxgl = _.get(window, 'mapboxgl'),
          mapConfig = _.get(window, 'mapConfig');

        // get all the states geometry and draw the map
        window.jQuery.get('/wp-content/themes/avma-journey/assets/data/albers-usa.json')
          .done(
            data => {
              const map = new mapboxgl.Map(mapConfig), // Mapbox map object
                usa = data, // USA geometry
                ResponsiveToolKit = _.get(window, 'ResponsiveToolKit'), // A utility for checking screen sizes
                pinUrl = '/wp-content/themes/avma-journey/assets/images/pins/', // path to where the pin images are
                preloadImageNames = [ // an array of pin images
                  'yellow-pin.png',
                  'red-pin.png',
                  'pink-pin.png',
                  'green-pin.png',
                  'teal-pin.png',
                  'brown-pin.png',
                  'blue-pin.png',
                  'purple-pin.png',
                  'gold-pin.png',
                  'fuchsia-pin.png',
                  'dark-green-pin.png',
                  'tan-pin.png',
                ],
                pinsLoaded = {}, // an array for loaded pins
                // pin settings, should be self-explanatory
                iconScale = _.get(window, 'pinScale'),
                pinFontSize = _.get(window, 'pinFontSize'),
                pinTextOffset = _.get(window, 'pinTextOffset'),
                pinTextPadding = _.get(window, 'pinTextPadding'),
                pinIconPadding = _.get(window, 'pinIconPadding'),
                // default settings for the mapbox pin layer
                pinLayerDefaults = {
                  type: 'symbol',
                  layout: {
                    'icon-size': iconScale,
                    'icon-anchor': 'bottom',
                    'icon-allow-overlap': true,
                    'icon-padding': pinIconPadding,
                    'text-field': ['get', 'name'],
                    'text-font': [
                      'Open Sans Semibold',
                      'Arial Unicode MS Bold'
                    ],
                    'text-size': pinFontSize,
                    'text-offset': pinTextOffset,
                    'text-anchor': 'top-left',
                    'text-allow-overlap': true,
                    'text-padding': pinTextPadding
                  },
                  paint: {
                    'text-halo-color': 'rgba(255,255,255,0.75)',
                    'text-halo-blur': 2,
                    'text-halo-width': 2
                  }
                };

              // make the map data globally accessible
              _.set(window, 'usaGeoJson', data);

              // Create our projection and make it globally accessible
              // This projection will help us map new pins to the map
              _.set(window, 'projection', geoAlbersUsaPr().scale(57).translate([360.0, 180.05]).precision(1));

              // Configure map settings and controls
              map.dragRotate.disable();
              map.touchZoomRotate.disableRotation();
              map.addControl(
                new mapboxgl.NavigationControl(
                  {
                    showCompass: false
                  }
                )
              );

              // Add map geometry, load pin images and add existing user pins once the map is ready
              map.on(
                'load',
                () => {
                  addUsaLayer();
                  fetchMarkerImages();
                  addUserPins();
                }
              );

              // Draws the USA map
              function addUsaLayer () {
                map.addSource(
                  'usa-data',
                  {
                    type: 'geojson',
                    data: usa
                  }
                );
                map.addLayer(
                  {
                    id: 'usa',
                    type: 'fill',
                    source: 'usa-data',
                    paint: {
                      'fill-color': '#c9c9c9',
                      'fill-outline-color': '#c9c9c9'
                    }
                  }
                );
              }

              // Loads up all the pin images and makes them accessible to mapbox
              function fetchMarkerImages () {
                _.forEach(
                  preloadImageNames,
                  (image) => {
                    const imgName = image.replace('.png', '');

                    _.set(pinsLoaded, `['${imgName}']`, false)

                    map.loadImage(
                      `${pinUrl}${image}`,
                      (error, img) => {
                        if (error) {
                          throw error;
                        }
                        map.addImage(imgName, img);
                        _.set(pinsLoaded, `['${imgName}']`, true);
                      }
                    );
                  }
                );
              }

              // Fetches all the existing pins and draws them on the map
              function addUserPins () {
                window.jQuery.get('/wp-json/avma/v1/pin/geojson')
                  .done(
                    data => {
                      const projection = _.get(window, 'projection'),
                        refreshInterval = _.get(window, 'refreshInterval');

                      _.set(window, 'totalPins', _.get(data, 'features.length'));
                      _.set(window, 'totalIntlPins', $('#internationalPins .pin').length);

                      // Pin data is using the standard Mercator projection, so we need to
                      // re-project it to fit on our Albers USA+PR map
                      _.forEach(
                        data.features,
                        (feature, index) => {
                          data.features[index] = d3.geoProject(feature, projection);
                        }
                      );

                      data.features.reverse();

                      // Add our re-projected map data to mapbox
                      map.addSource(
                        'all-users',
                        {
                          type: 'geojson',
                          data: data
                        }
                      );

                      // Finalize our pin later settings and link it to the pin data
                      const layerCfg = _.cloneDeep(pinLayerDefaults);

                      _.set(layerCfg, 'id', 'user-pins');
                      _.set(layerCfg, 'source', 'all-users');
                      _.set(layerCfg, 'layout["icon-image"]', ['get', 'pin']);
                      _.set(layerCfg, 'layout["icon-allow-overlap"]', false);
                      _.set(layerCfg, 'layout["text-allow-overlap"]', false);
                      _.set(layerCfg, 'layout["visibility"]', 'visible');

                      // Add the layer to the map to show the pins.
                      map.addLayer(layerCfg);

                      // set up to fetch new map data
                      const initialTimeout = window.setTimeout(
                        function () {
                          window.clearTimeout(_.get(window, 'initialTimeout'));
                          fetchNewUserPins();
                          fetchNewIntlPins();
                        },
                        refreshInterval
                      );

                      _.set(window, 'initialTimeout', initialTimeout);
                    }
                  );
              }

              /**
               * Queries the DB for any new pins that should be listed in the International participants list
               */
              function fetchNewIntlPins () {
                let totalIntlPins = _.get(window, 'totalIntlPins');

                window.clearTimeout(_.get(window, 'intlTimeout'));

                // check to see if we have new data
                window.jQuery.get('/wp-json/avma/v1/pin/international/count')
                  .done(
                    count => {
                      // if we have new pins, add them
                      if (count > totalIntlPins) {
                        // fetch new pin data
                        window.jQuery.get(`/wp-json/avma/v1/pin/international/chunk?s=${totalIntlPins}`)
                          .done(
                            // once we get data, create the appropriate list items and add them to the sidebar
                            data => {
                              const list = $('#internationalPins')
                              totalIntlPins += _.get(data, 'pins.length');
                              _.set(window, 'totalIntlPins', totalIntlPins);

                              _.forEach(
                                data.pins,
                                (pin, index) => {
                                  const item = $('<li>')
                                    .addClass('pin')
                                    .addClass('pin-new')
                                    .addClass('pin-' + _.get(pin, 'pin').replace('-pin', ''))
                                    .text(_.get(pin, 'name'));
                                  list.prepend(item);

                                  window.setTimeout(
                                    function () {
                                      item.addClass('pin-new-fade')
                                    }
                                    , 500
                                  );

                                  // don't forget to update the counter if it is showing
                                  window.jQuery.get('/wp-json/avma/v1/pin/count').done(
                                    total => {
                                      const counterElem = $('#totalCount');

                                      if (counterElem.length > 0) {
                                        counterElem.text(total.toString());
                                      }
                                    }
                                  );
                                }
                              );
                            }
                          );
                      }
                    }
                  )
                  .always(
                    () => {
                      // Make sure we run this again to make sure the list is updated on the regular
                      const refreshInterval = _.get(window, 'refreshInterval'),
                        intlTimeout = window.setTimeout(fetchNewIntlPins, refreshInterval);

                      _.set(window, 'intlTimeout', intlTimeout);
                    }
                  )
              }

              // query the DB for new pins that need to be added to the map
              function fetchNewUserPins () {
                let totalPins = _.get(window, 'totalPins');

                window.clearTimeout(_.get(window, 'pinTimeout'));

                // find out if we have new pins we need to add
                window.jQuery.get('/wp-json/avma/v1/pin/geojson/count')
                  .done(
                    count => {
                      // if we have new pins, fetch the data and add them
                      if (count > totalPins) {
                        window.jQuery.get(`/wp-json/avma/v1/pin/geojson/chunk?s=${totalPins}`)
                          .done(
                            // once the data is received, make sure we re-project their data to Albers
                            // then ensure it is added to the map
                            data => {
                              const projection = _.get(window, 'projection'),
                                timeStamp = Math.floor((new Date()).getTime() / 1000).toString(),
                                sourceName = `new-users-${timeStamp}`,
                                layerName = `new-user-pins-${timeStamp}`,
                                lastLayer = _.get(window, 'lastLayer', '');

                              totalPins += _.get(data, 'features.length');
                              _.set(window, 'totalPins', totalPins);

                              _.forEach(
                                data.features,
                                (feature, index) => {
                                  data.features[index] = d3.geoProject(feature, projection);
                                }
                              );

                              map.addSource(
                                sourceName,
                                {
                                  type: 'geojson',
                                  data: data
                                }
                              );

                              const layerCfg = _.cloneDeep(pinLayerDefaults);

                              _.set(layerCfg, 'id', layerName);
                              _.set(layerCfg, 'source', sourceName);
                              _.set(layerCfg, 'layout["icon-image"]', ['get', 'pin']);
                              _.set(layerCfg, 'layout["icon-allow-overlap"]', true);
                              _.set(layerCfg, 'layout["text-allow-overlap"]', true);
                              _.set(layerCfg, 'layout["visibility"]', 'visible');

                              if (!_.isEmpty(lastLayer)) {
                                map.setLayoutProperty(lastLayer, 'icon-allow-overlap', false);
                                map.setLayoutProperty(lastLayer, 'text-allow-overlap', false);
                              }

                              _.set(window, 'lastLayer', layerName);

                              map.addLayer(layerCfg);

                              // don't forget to update the counter if it is showing
                              window.jQuery.get('/wp-json/avma/v1/pin/count').done(
                                total => {
                                  const counterElem = $('#totalCount');

                                  if (counterElem.length > 0) {
                                    counterElem.text(total.toString());
                                  }
                                }
                              );
                            }
                          );
                      }
                    }
                  )
                  .always(
                    // Make sure we run this again to make sure the map is updated on the regular
                    () => {
                      const refreshInterval = _.get(window, 'refreshInterval'),
                        pinTimeout = window.setTimeout(fetchNewUserPins, refreshInterval);

                      _.set(window, 'pinTimeout', pinTimeout);
                    }
                  )
              }

              // The following two functions help ensure the map is displayed properly, regardless of
              // what screen size the map is being viewed on.

              /**
               * Make sure the boundary of the map is always showing the USA+Alaska+Hawaii+PR
               */
              function adjustMapBounds () {
                const maxBounds545 = [
                    [-33.32843305753181, -17.888296020530674],
                    [31.66086706516637, 14.162008824413036]
                  ],
                  maxBounds = map.getMaxBounds().toArray();

                if (ResponsiveToolKit.width() >= 545) {
                  if (!_.isEqual(maxBounds, maxBounds545)) {
                    map.setMaxBounds(maxBounds545);
                  }
                } else {
                  if (!_.isEqual(maxBounds, _.get(mapConfig, 'maxBounds'))) {
                    map.setMaxBounds(_.get(mapConfig, 'maxBounds'));
                  }
                }
              }

              /**
               * Make sure the map zoom level is adjusted accordingly
               */
              function adjustMapZoom () {
                const widthNow = ResponsiveToolKit.width(),
                  zoomDiffSm = 0.94,
                  zoomDiff = 1.4,
                  threeTwenty = 320,
                  fiveFortyFive = 545,
                  pixelDiffSm = 224,
                  pixelDiff = 695,
                  pixelIncreaseSm = zoomDiffSm / pixelDiffSm,
                  pixelIncrease = zoomDiff / pixelDiff;
                let newZoom, minSize, increase, minZoom, maxZoom;

                if (widthNow < 545) {
                  minSize = threeTwenty;
                  increase = pixelIncreaseSm;
                  minZoom = _.get(mapConfig, 'zoom');
                  maxZoom = minZoom + zoomDiffSm;
                } else {
                  minSize = fiveFortyFive;
                  increase = pixelIncrease;
                  minZoom = zoom545;
                  maxZoom = minZoom + zoomDiff;
                }

                newZoom = ((widthNow - minSize) * increase) + minZoom;

                if (newZoom > maxZoom) {
                  newZoom = maxZoom;
                } else if (newZoom < minZoom) {
                  newZoom = minZoom;
                }

                if (!_.isUndefined(newZoom)) {
                  map.setZoom(newZoom);
                }

                currentScreenWith = widthNow;
              }

              const zoom545 = 2;
              let currentScreenWith = ResponsiveToolKit.width();

              // Set up an observer to watch for changes in screen size
              const observer = ResponsiveToolKit.observe(
                () => {
                  adjustMapBounds();
                  adjustMapZoom();
                }
              );

              // ensure the map is adjusted for the initial view
              adjustMapBounds();
              adjustMapZoom();

              _.set(window, 'map', map);
            }
          );
      }
    );
  }
)(window, document, window.jQuery, window.lodash);
